"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const clsx_1 = __importDefault(require("clsx"));
const helper_1 = require("../../helper");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const left_nav_1 = require("../../constants/left-nav");
const USER_ID = helper_1.USER.id;
const LeftNavFilter = (props) => {
    const { changeFilterParam, filterFlyoutParam, defaultLeftNav = 0 } = props;
    const initialSelectedItem = (0, react_1.useMemo)(() => {
        if (defaultLeftNav > 0) {
            return { parentIndex: 0, childIndex: 1 };
        }
        return { parentIndex: 0, childIndex: 0 };
    }, [defaultLeftNav]);
    const [selectedItem, setSelectedItem] = (0, react_1.useState)(initialSelectedItem);
    const resetFilter = (e) => {
        setSelectedItem({ parentIndex: 0, childIndex: 0 });
        changeFilterParam({ param: {}, title: left_nav_1.ITEMS_MENU[0].label });
    };
    (0, react_1.useEffect)(() => {
        document.addEventListener('reset-filter-left-nav', resetFilter);
        return () => {
            document.removeEventListener('reset-filter-left-nav', resetFilter, false);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (!(0, isEqual_1.default)(filterFlyoutParam, {})) {
            setSelectedItem({ parentIndex: 0, childIndex: 0 });
            changeFilterParam({ param: {}, title: left_nav_1.ITEMS_MENU[0].label });
        }
    }, [filterFlyoutParam]);
    const handleSelected = (selection) => {
        setSelectedItem(selection);
        if (selection.childIndex === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.childIndex)) {
            return;
        }
        let param = {};
        switch (selection.childIndex) {
            case 0:
                param = {};
                break;
            case 1:
                param = { member_id: USER_ID };
                break;
            case 2:
                param = { created_by_id: USER_ID };
                break;
            default:
                break;
        }
        const filterResetEvent = new CustomEvent('reset-filter-flyout', {
            detail: {},
        });
        document.dispatchEvent(filterResetEvent);
        changeFilterParam({
            param: (0, helper_1.filterParams)(param),
            title: left_nav_1.ITEMS_MENU[selection.childIndex].label,
        });
    };
    const handleDebounceSearch = (0, lodash_1.debounce)(({ target }) => {
        const changeSearchValueEvent = new CustomEvent('document-reviews-search-input', {
            detail: target.value,
        });
        document.dispatchEvent(changeSearchValueEvent);
    }, 500);
    const generateFilterPresets = () => {
        return [
            {
                title: 'Preset Filters',
                children: left_nav_1.ITEMS_MENU === null || left_nav_1.ITEMS_MENU === void 0 ? void 0 : left_nav_1.ITEMS_MENU.map((item) => {
                    return (react_1.default.createElement(pulse_components_1.PulseTooltip, { key: item.label, classes: {
                            childrenRoot: styles_modules_less_1.default.presetOption,
                        }, TippyProps: {
                            content: item.label,
                            placement: 'top',
                        } }, item.label));
                }),
            },
        ];
    };
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default.leftNavReview },
        react_1.default.createElement("div", { className: "v3-form-control__wrapper", style: { width: 232 } },
            react_1.default.createElement("label", { className: "v3-form-control__prefix", htmlFor: "preview-quick-search" },
                react_1.default.createElement("i", { className: "fas fa-search" })),
            react_1.default.createElement("input", { id: "preview-quick-search", className: (0, clsx_1.default)('v3-form-control', styles_modules_less_1.default.previewQuickSearch), placeholder: "Quick Search", onChange: handleDebounceSearch })),
        react_1.default.createElement("div", { className: styles_modules_less_1.default.leftNavFilter }, left_nav_1.ITEMS_MENU && (react_1.default.createElement(pulse_components_1.PulseLeftNavTree, { filters: generateFilterPresets(), designVariant: "v3", onFilterSelection: handleSelected, selectedIndices: selectedItem, classes: {
                selected: styles_modules_less_1.default.selectedItem,
            } })))));
};
exports.default = LeftNavFilter;
